import React, { useState } from 'react';
import { TAU } from 'zdog';
import { Illustration, Anchor, Box, Cylinder } from 'react-zdog';
import Animator from '../util/animator';

interface AnimaProps {
  color: string;
  stemColor: string;
  lineLength: string;
  strokeWidth: string;
  showStem: boolean;
  zoom: number;
}

function Anima({
  color,
  stemColor,
  lineLength,
  strokeWidth,
  showStem,
  zoom,
}: AnimaProps) {
  const [isSpinning, setSpinning] = useState(true);
  // const strokeWidth = 1;
  // const lineLength = lineLength;
  return (
    <Illustration
      element="canvas"
      zoom={zoom}
      dragRotate
      onDragStart={() => setSpinning(false)}
      onDragEnd={() => setSpinning(true)}
    >
      <Animator action={isSpinning ? `spin` : null}>
        <Anchor rotate={{ x: TAU / 10, y: TAU / 8 }}>
          {[-4, 4].map((x) =>
            [-4, 4].map((y) =>
              [-4, 4].map((z) => (
                <Box
                  // stroke={1}
                  // strokeColor="red"
                  width={strokeWidth}
                  height={strokeWidth}
                  depth={strokeWidth}
                  stroke={strokeWidth}
                  translate={{ x, y, z }}
                  color={color}
                />
              )),
            ),
          )}
          {showStem &&
            [{}, { y: TAU / 4 }, { x: TAU / 4 }].map((a) =>
              [-4, 4].map((x) =>
                [-4, 4].map((y) => (
                  <Anchor rotate={a}>
                    <Cylinder
                      stroke={strokeWidth}
                      diameter={strokeWidth}
                      length={lineLength}
                      color={stemColor}
                      translate={{ x, y }}
                    />
                  </Anchor>
                )),
              ),
            )}
        </Anchor>
      </Animator>
    </Illustration>
  );
}

export default Anima;
